<template>
  <sc-card :title="$t(`events-log`)" v-loading="!initialRequest">
    <div :class="`sc-events-log ${type}`">
      <sc-events-log-list
        :events-data="eventsData"
        v-if="eventsData"
        :type="type"
      />
    </div>
  </sc-card>
</template>

<script>
import scCard from "../../layout/card";
import scEventsLogList from "./components/events-log-list";

export default {
  props: {
    options: {
      type: Object
    }
  },
  components: {
    scCard,
    scEventsLogList
  },
  data() {
    return {
      titleIcon: {
        name: "traffic-cone",
        color: "#FF3E3E"
      }
    };
  },
  computed: {
    eventsInfo() {
      return this.$store.state.situationCenter.events;
    },
    eventsData() {
      return this.$store.state.situationCenter.layersData.map.events || null;
    },
    type() {
      return this.options.type || "type-1";
    },
    initialRequest() {
      return (
        this.$store.state.situationCenter.completedRequests.indexOf(
          this.options.layer_id
        ) !== -1
      );
    }
  }
};
</script>

<style lang="scss">
.sc-events-log {
  width: 440px;
  &.type-2 {
    width: 800px;
  }
}
</style>

<i18n>
{
  "ru": {
    "events-log": "Журнал событий"
  },
  "en": {
    "events-log": "Events log"
  }
}
</i18n>
